export default __webpack_public_path__ + "static/media/pic6.c6a8fc88.jpg";